import "whatwg-fetch";
import { checkFetchStatus } from "@stofloos/actions/auth";
export const AUTH_HOST = process.env.AUTH_HOST;

export const SET_PROFILE = "SET_PROFILE";
export const SET_FETCHING = "SET_FETCHING";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SET_WALLET = "SET_WALLET";
export const SET_WALLET_STATS = "SET_WALLET_STATS";

export const updateProfile = profile => {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const state = getState();
			if (state.StofwareAuth.access_token && state.StofwareAuth.user) {
				if (state.StofwareAuth.access_token && state.StofwareAuth.user.user_claims) {
					fetch(`${AUTH_HOST}/userprofile/` + state.StofwareAuth.user.user_claims.user_profile_id, {
						method: "PUT",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + state.StofwareAuth.access_token
						},
						body: JSON.stringify(profile)
					})
						.then(checkFetchStatus(dispatch, getState))
						.then(res => res.json())
						.then(data => {
							if (data.status === "error") {
								reject(data);
							} else {
								dispatch(setProfile(data));
								resolve();
							}
						})
						.catch(e => {
							reject(e);
							dispatch(error(e));
						});
				}
			}
		});
};

export const getProfile = (dispatch, getState) => {
	const state = getState();
	if (state.StofwareAuth.access_token && state.StofwareAuth.user) {
		if (state.StofwareAuth.access_token && state.StofwareAuth.user.user_claims) {
			dispatch(setFetchProfile(true));

			fetch(`${AUTH_HOST}/userprofile/` + state.StofwareAuth.user.user_claims.user_profile_id, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + state.StofwareAuth.access_token
				}
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error") {
					} else {
						dispatch(setProfile(data));
					}
				})
				.catch(e => dispatch(error(e)));
		}
	}
};

export const getWallet = (dispatch, getState) => {
	const state = getState();
	if (state.StofwareAuth.access_token && state.StofwareAuth.user) {
		if (state.StofwareAuth.access_token && state.StofwareAuth.user.user_claims) {
			dispatch(setFetchProfile(true));

			let url = new URL(`${AUTH_HOST}/wallet`);
			let params = {
				single: false,
				filters: JSON.stringify([
					{ name: "user_profile_id", op: "eq", value: state.StofwareAuth.user.user_claims.user_profile_id }
				])
			};

			url.search = new URLSearchParams(params);

			fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + state.StofwareAuth.access_token
				}
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error") {
					} else {
						const wallets = data.objects;
						dispatch(setWallet(wallets));
					}
				})
				.catch(e => dispatch(error(e)));
		}
	}
};

export const getWalletStats = (dispatch, getState) => {
	const state = getState();

	if (state.StofwareAuth.access_token && state.StofwareAuth.user) {
		fetch(`${AUTH_HOST}/wallet/` + state.StofwareAuth.user.user_claims.wallet_id + "/stats", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + state.StofwareAuth.access_token
			}
		})
			.then(checkFetchStatus(dispatch, getState))
			.then(function(response) {
				return response.json();
			})
			.then(
				function(data) {
					dispatch(setWalletStats(data));
				}.bind(this)
			);
	}
};

export const setFetchProfile = isFetching => {
	return {
		type: SET_FETCHING,
		isFetching
	};
};

export const setProfile = profile => {
	return {
		type: SET_PROFILE,
		profile
	};
};

export const setWallet = wallet => {
	return {
		type: SET_WALLET,
		wallet
	};
};

const setWalletStats = gamification => {
	return {
		type: SET_WALLET_STATS,
		gamification
	};
};
